var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyChf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136724)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136724)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 43.1153,
    height: 28.6785,
    rx: 5.38875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.5 0H35.6153V28.6785H-7.5V0Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1689 4.71729H16.9419V11.4525H23.6772V17.2256H16.9419V23.9609H11.1689V17.2256H4.43359V11.4525H11.1689V4.71729Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136724"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 43.1153,
    height: 28.6785,
    rx: 5.38875,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyChf);
export default __webpack_public_path__ + "static/media/Currency=CHF.da8aafb6eece04dc96d57ba973370194.svg";
export { ForwardRef as ReactComponent };